<script setup lang="ts">
import { useAppSettingsStore } from '@convatec/180medical-website/app/stores/app-settings'

const props = defineProps({
  title: {
    type: String,
  },
})

const appSettingsStore = useAppSettingsStore()

useHubSpotFormA11y('hs-sb-contact-form-container', props.title || 'Contact us')

useHubSpotFormHtml('hs-sb-contact-form-container', () => ({
  portalId: appSettingsStore?.contactSettings?.portalId,
  formId: appSettingsStore?.contactSettings?.formId,
}))
</script>

<template>
  <div class="side-form-block">
    <div
      v-if="title"
      class="h2 side-form-block__title"
    >
      {{ title }}
    </div>
    <div class="side-form-block__body prose">
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/blocks/side-form-block.scss';
</style>
